module.exports = __webpack_public_path__ + "static/media/generate_link_icon.905dab21.svg";